/* Inventory state is server rendered. This module never enables purchasing,
 * changes a selling plan or supplies an ETA. The sole added property identifies a preorder. */
if (!customElements.get('mms-preorder-state')) {
  customElements.define('mms-preorder-state', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.defaultSticky = this.root.querySelector('[data-mila-return]')?.dataset.defaultLabel || 'Choose options';
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(() => {
        if (this.scheduled) return;
        this.scheduled = true;
        queueMicrotask(() => { this.scheduled = false; if (this.isConnected) this.sync(); });
      });
      this.observer.observe(this.root, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data?.sectionId) !== String(this.dataset.section)) return;
          const fresh = [...data.html.querySelectorAll('mms-preorder-state')].find(node => node.dataset.section === this.dataset.section);
          if (!fresh) return;
          this.dataset.variantId = fresh.dataset.variantId;
          this.dataset.oos = fresh.dataset.oos;
          this.dataset.allowed = fresh.dataset.allowed;
          const notice = this.querySelector('[data-preorder-notice]');
          const next = fresh.querySelector('[data-preorder-notice]');
          if (notice && next) { notice.hidden = next.hidden; if (notice.textContent !== next.textContent) notice.textContent = next.textContent; }
          this.sync();
        });
      }
      this.sync();
    }
    sync() {
      const form = this.closest('form');
      // Wait for the section response: the variant input changes before fresh inventory arrives.
      if (!form || String(form.querySelector('[name="id"]')?.value) !== this.dataset.variantId) return;
      const out = this.dataset.oos === 'true';
      const allowed = this.dataset.allowed === 'true';
      const property = this.querySelector('[data-mms-preorder-property]');
      if (property && property.disabled === (out && allowed)) property.disabled = !(out && allowed);
      const button = form.querySelector('.product-form__submit');
      // Do not rewrite loading, adding, or app busy states. Observe completion to resync.
      if (button?.classList.contains('loading') || button?.getAttribute('aria-disabled') === 'true' || form.querySelector('.restock-rocket-preorder-button[aria-disabled="true"]')) return;
      const label = button?.querySelector(':scope > span:not(.loading__spinner):not([data-mms-diffuser-price])');
      const write = (node, text) => { if (node && node.textContent.trim() !== text) node.textContent = text; };
      if (out && allowed) write(label, 'Preorder');
      else if (out && button?.disabled) write(label, 'Preorder unavailable');
      else if (!out && label?.textContent.trim() === 'Preorder') write(label, window.variantStrings?.addToCart || 'Add to cart');
      // Exact verified STOQ button only: preserve all app inputs, descriptions and handlers.
      if (out && allowed) this.root.querySelectorAll('.restock-rocket-preorder-button').forEach(appButton => {
        write(appButton.querySelector(':scope > span:not([data-mms-diffuser-price]):not(.loading__spinner)'), 'Preorder');
      });
      const sticky = this.root.querySelector('[data-mila-return]');
      if (!sticky?.hasAttribute('data-mms-diffuser-sticky')) write(sticky, out ? (allowed ? 'Preorder' : 'Preorder unavailable') : this.defaultSticky || 'Choose options');
      // Sticky remains an options link, not a purchase action; native disabled state is untouched.
    }
    disconnectedCallback() { this.observer?.disconnect(); this.unsubscribe?.(); }
  });
}
